import ProjectsService from '../../services/projects.service';

// Action Types
export const FETCH_PROJECTS_REQUEST = 'FETCH_PROJECTS_REQUEST';
export const FETCH_PROJECTS_SUCCESS = 'FETCH_PROJECTS_SUCCESS';
export const FETCH_PROJECTS_FAILURE = 'FETCH_PROJECTS_FAILURE';

export const DELETE_PROJECT_REQUEST = 'DELETE_PROJECT_REQUEST';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const DELETE_PROJECT_FAILURE = 'DELETE_PROJECT_FAILURE';
export const CLEAR_PROJECT_ERROR = 'CLEAR_PROJECT_ERROR';

export const SET_CURRENT_PROJECT = 'SET_CURRENT_PROJECT';
export const CLEAR_CURRENT_PROJECT = 'CLEAR_CURRENT_PROJECT';

// Tenant-related action types
export const FETCH_TENANTS_BY_PROJECT_REQUEST = 'FETCH_TENANTS_BY_PROJECT_REQUEST';
export const FETCH_TENANTS_BY_PROJECT_SUCCESS = 'FETCH_TENANTS_BY_PROJECT_SUCCESS';
export const FETCH_TENANTS_BY_PROJECT_FAILURE = 'FETCH_TENANTS_BY_PROJECT_FAILURE';
export const CLEAR_TENANTS_DATA = 'CLEAR_TENANTS_DATA';

// Action Creators

/**
 * Fetch all projects with pagination
 */
export const fetchProjects = ({ pageNumber = 1, pageSize = 10, searchTerm = '' } = {}) => async dispatch => {
  dispatch({ type: FETCH_PROJECTS_REQUEST });
  
  try {
    const response = await ProjectsService.getAllProjects(pageNumber, pageSize, searchTerm);
    dispatch({
      type: FETCH_PROJECTS_SUCCESS,
      payload: {
        ...response,
        searchTerm
      }
    });
  } catch (error) {
    dispatch({
      type: FETCH_PROJECTS_FAILURE,
      payload: error.message || 'Failed to fetch projects'
    });
  }
};

/**
 * Delete project
 */
export const deleteProject = (id) => async dispatch => {
  dispatch({ type: DELETE_PROJECT_REQUEST });
  
  try {
    await ProjectsService.deleteProject(id);
    dispatch({
      type: DELETE_PROJECT_SUCCESS,
      payload: id
    });
    // Fetch fresh data after delete to ensure consistency
    dispatch(fetchProjects());
  } catch (error) {
    dispatch({
      type: DELETE_PROJECT_FAILURE,
      payload: error.message || 'Failed to delete project'
    });
    // The screen shows why it failed.
    throw error;
  }
};

/**
 * Clear project error
 */
export const clearProjectError = () => dispatch => {
  dispatch({ type: CLEAR_PROJECT_ERROR });
};

/**
 * Fetch tenants by project ID with pagination and search
 */
export const fetchTenantsByProject = (projectId, { pageNumber = 1, pageSize = 10, searchTerm = '' } = {}) => async dispatch => {
  dispatch({ type: FETCH_TENANTS_BY_PROJECT_REQUEST });
  
  try {
    const response = await ProjectsService.getProjectResidents(projectId); // Pagination handled client side for now/ignored
    dispatch({
      type: FETCH_TENANTS_BY_PROJECT_SUCCESS,
      payload: {
        ...response,
        searchTerm
      }
    });
  } catch (error) {
    dispatch({
      type: FETCH_TENANTS_BY_PROJECT_FAILURE,
      payload: error.message || 'Failed to fetch tenants'
    });
  }
};

/**
 * Clear tenants data
 */
export const clearTenantsData = () => dispatch => {
  dispatch({ type: CLEAR_TENANTS_DATA });
};

export const setCurrentProject = (project) => dispatch => {
  if (!project) {
    return;
  }

  dispatch({
    type: SET_CURRENT_PROJECT,
    payload: project
  });
};

export const clearCurrentProject = () => dispatch => {
  dispatch({ type: CLEAR_CURRENT_PROJECT });
};
